import graphql from "babel-plugin-relay/macro";

const UserPortfolioQuery = graphql`
query UserPortfolioQuery{
  userPortfolio{
      marketCurrentTotal
      percentageDiff
      invested
      profitLoss  
  }
}
`

export default UserPortfolioQuery;